import { render, staticRenderFns } from "./SchoolNotFoundWarning.vue?vue&type=template&id=0eb3e53c&scoped=true"
import script from "./SchoolNotFoundWarning.vue?vue&type=script&lang=ts"
export * from "./SchoolNotFoundWarning.vue?vue&type=script&lang=ts"
import style0 from "./SchoolNotFoundWarning.vue?vue&type=style&index=0&id=0eb3e53c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb3e53c",
  null
  
)

export default component.exports